import { render, staticRenderFns } from "./Froala.vue?vue&type=template&id=27f51a9e&"
import script from "./Froala.vue?vue&type=script&lang=js&"
export * from "./Froala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports